<section class="status-page">
  <h1 class="number status-page__title">404</h1>
  <h2 class="description status-page__description">Sorry, but the page doesn't exists!</h2>
  <h3 class="status-page__action">Would you like to go <a href="#/">home</a>?</h3>
</section>
